export default __webpack_public_path__ + "static/media/ethereum.07686c97.svg";